import { RangeSelectorPosition } from '@polestar/component-warehouse-react/components/range-selector/RangeSelector';
/**
 * Make sure the positions don't overlap
 */
export const clampPositions = (position, newStart, newEnd) => {
    if (position === RangeSelectorPosition.max && newStart > newEnd) {
        return [newEnd, newEnd];
    }
    else if (position === RangeSelectorPosition.min && newEnd < newStart) {
        return [newStart, newStart];
    }
    return [newStart, newEnd];
};
/**
 * Helper function to manage animation controls consistently
 */
export const handleAnimation = (animation, target, { animate, isDragging, hasAnimationTransition, }) => {
    if (!animate && !isDragging) {
        animation.stop();
        animation.set(target);
        return;
    }
    if (hasAnimationTransition) {
        void animation.start(target);
    }
    else {
        animation.set(target);
    }
};
